import {
  Fieldset,
  FieldsetLegend,
} from "@imi/ui/components/Fieldset/Fieldset.js";
import { UnitsOptions } from "@src/core/engine/units/unitsRepository";
import { useTranslation } from "react-i18next";
import { useUnitsForm } from "../hooks/useUnitsForm";

type GeometricDimensionsProps = {
  form: ReturnType<typeof useUnitsForm>["form"];
  unitsOptions: UnitsOptions;
};

export function GeometricDimensions({
  form,
  unitsOptions,
}: GeometricDimensionsProps) {
  const { t } = useTranslation("settings", { keyPrefix: "units" });

  return (
    <Fieldset>
      <FieldsetLegend>{t("geometricDimensions.title")}</FieldsetLegend>
      <form.AppField name="length">
        {(field) => (
          <field.Select label={t("geometricDimensions.fields.length")}>
            {unitsOptions.length.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="diameter">
        {(field) => (
          <field.Select label={t("geometricDimensions.fields.diameter")}>
            {unitsOptions.diameter.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="roughness">
        {(field) => (
          <field.Select label={t("geometricDimensions.fields.roughness")}>
            {unitsOptions.roughness.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="thickness">
        {(field) => (
          <field.Select label={t("geometricDimensions.fields.thickness")}>
            {unitsOptions.thickness.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="area">
        {(field) => (
          <field.Select label={t("geometricDimensions.fields.area")}>
            {unitsOptions.area.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="volume">
        {(field) => (
          <field.Select label={t("geometricDimensions.fields.volume")}>
            {unitsOptions.volume.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>
    </Fieldset>
  );
}
